import { store } from '@/store';
import QuestionBuilder from './QuestionBuilder';

export default class FuelTypeQuestionBuilder extends QuestionBuilder {
    public constructor() {
        super(true, false);
    }

    answers() {
        return store.getters['vehicleSearchModule/fuelTypes'];
    }

    setAnswer(answer: string) {
        store.dispatch('vehicleModule/submitFuelTypes', null);
        store.dispatch('vehicleModule/submitFuelTypes', [answer]);
        store.dispatch('vehicleSearchModule/updateFilteredResults');
    }
}
